import React, { Fragment } from "react";

interface propsTypes {
  children?: React.ReactNode;
  innerHtml?: string;
  className?: string;
  onClick?: (() => void | undefined) | undefined;
}

const P = (props: propsTypes) => {
  const { children, innerHtml } = props;
  return (
    <Fragment>
      {innerHtml ? <p dangerouslySetInnerHTML={{ __html: innerHtml }} /> : ""}
      <p {...props}>{children}</p>
    </Fragment>
  );
};

export default P;
